import React from 'react'
import PropTypes from 'prop-types'
import '../css/FICLink.css'
import FICIcon from 'common/components-v2/FICIcon/FICIcon'

export default function FICLink ({ className, onClick, href, target, style, text, inline, disabled, iconLeft }) {
  let linkProps = {
    onClick: onClick,
    href: href,
    target: target
  }
  let innerClassName = className ? className + ' FICLink' : 'FICLink'
  if (disabled) { innerClassName += ' FICLink-disabled' }
  return <div className={innerClassName} style={{
    ...style,
    display: inline ? 'inline' : style.display
  }}>
    <a {...linkProps}>
      {iconLeft && <FICIcon name={iconLeft} style={{ marginRight: text ? 4 : 0 }} />}
      {text}
    </a>
  </div>
}

FICLink.propTypes = {
  target: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
  disabled: PropTypes.bool,
  style: PropTypes.object,
  inline: PropTypes.bool,
  iconLeft: PropTypes.string,
  className: PropTypes.string
}

FICLink.defaultProps = {
  target: '_self',
  href: undefined,
  onClick: undefined,
  text: undefined,
  disabled: undefined,
  style: {},
  inline: false,
  iconLeft: null,
  className: null
}



// WEBPACK FOOTER //
// ./src/common/components/js/FICLink.js